import { render } from "./ComponentAlignment.vue?vue&type=template&id=f4417cc4&scoped=true"
import script from "./ComponentAlignment.vue?vue&type=script&lang=js"
export * from "./ComponentAlignment.vue?vue&type=script&lang=js"

import "./ComponentAlignment.vue?vue&type=style&index=0&id=f4417cc4&scoped=true&lang=css"

import exportComponent from "D:\\PhpstormProjects\\alignment-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4417cc4"]])

export default __exports__